import { Component } from "@theme/component";
import { debounce, fetchConfig } from "@theme/utilities";

/**
 * MRB: persists the "PO Number" cart attribute as it is typed
 * (same shape as the theme's cart-note.js / gift-wrapping.js).
 */
class CartPoNumber extends Component {
  /** @type {AbortController | null} */
  #activeFetch = null;

  /**
   * @param {InputEvent} event - input event from the PO number field.
   */
  updatePoNumber = debounce(async (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;

    const value = event.target.value.trim();
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }

    const abortController = new AbortController();
    this.#activeFetch = abortController;

    try {
      const config = fetchConfig("json", {
        body: JSON.stringify({ attributes: { "PO Number": value } }),
      });

      await fetch(FoxTheme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal,
      });
    } catch (error) {
    } finally {
      this.#activeFetch = null;
    }
  }, 300);
}

if (!customElements.get("cart-po-number")) {
  customElements.define("cart-po-number", CartPoNumber);
}
